import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M7.3 13.5c.4.4 1 .4 1.4 0l5.6-5.7c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-5.2 5.1V.6c0-.3-.2-.5-.5-.5s-.5.2-.5.5v11.7L2.3 7.2c-.1-.2-.5-.2-.7 0s-.2.5 0 .7zM14 15H2c-.3 0-.5.2-.5.5s.2.5.5.5h12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5" />
  </svg>
);
const SvgContainerArrowDownNext = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="container-arrow-down-next" {...props} />;
export default SvgContainerArrowDownNext;
